module.exports = __webpack_public_path__ + "assets/img/vtuber-ads9.4422250d.png";